var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.429,
    height: 57.541,
    viewBox: "0 0 33.429 57.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-quote",
    "data-name": "Icon metro-quote",
    d: "M8.355,38.41v28.77H21.727V38.41H15.041s0-14.385,6.686-14.385V9.64S8.355,9.64,8.355,38.41ZM41.784,24.025V9.64s-13.372,0-13.372,28.77v28.77H41.784V38.41H35.1S35.1,24.025,41.784,24.025Z",
    transform: "translate(-8.355 -9.64)",
    fill: "#d2ddf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/QuoteIcon.d5d42cbdf186888c3d75ab1da35f8ecd.svg";
export { ForwardRef as ReactComponent };